import { Currency } from '@pp/core/entities';

export enum ChangeType {
  decrease,
  increase,
}

export interface CryptoMarketRate {
  price: string;
  priceCurrency: Currency;
  coinCurrency: Currency;
  changeTime: CryptoMarketChangeTime;
  marketCap: number;
}

export interface CryptoMarketChangeTime {
  percents: string;
  changeType: ChangeType;
}
